<template>
  <div class="bleedout to-edge">
    <ProductGrid
      :id="system.id"
      :initialFilter="initialFilter"
      :tiles="tiles"
      :pageSize="pageSize"
      :defaultSort="data.sort"
      :primaryHeading="data.title"
    ></ProductGrid>
  </div>
</template>

<script>
import ProductGrid from '@/components/browseNa/ProductGrid.vue';
import { useContentful, contentfulProps } from '@/compositions/useContentful.js';
import { computed } from 'vue';

export default {
  components: {
    ProductGrid,
  },
  props: contentfulProps,
  async setup(props, ctx) {
    const { data, init, system } = useContentful('productGrid', props, ctx, { errorPolicy: 'ignore' });
    await init();

    const initialFilter = {
      marketingTags: data.value.marketingTags,
      taxonomyCategories: data.value.taxonomyCategories,
      taxonomyAttributes: data.value.taxonomyAttributes,
      onSale: data.value.saleFilter === 'Sale Products' || data.value.saleFilter === 'Sale & Clearance Products',
      onClearance: data.value.saleFilter === 'Clearance Products' || data.value.saleFilter === 'Sale & Clearance Products',
      collectionIds: data.value.collectionIds ? data.value.collectionIds.map(Number).filter(Boolean) : [], 
    };

    const tiles = computed(() => {
      return data.value.tileStyle
        ? [
            {
              tileContent: data.value.tileStyle,
              tileSize: {
                ratio320px: data.value.ratio320px,
                ratio768px: data.value.ratio768px,
                ratio1200px: data.value.ratio1200px,
                ratio1400px: data.value.ratio1400px,
                ratio1800px: data.value.ratio1800px,
              },
            },
          ]
        : [];
    });

    return {
      data,
      system,
      tiles,
      initialFilter,
      pageSize: parseInt(data.value.pageSize, 10) || 24,
    };
  },
};
</script>

<style lang="postcss"></style>
